import { useEffect } from "react";
import type { GetUserQuery } from "graphql/generated";
import { IssueReporter } from "utils/issueReporter";

/**
 * Sends the user to Sentry each time the id, the name or the email changes.
 * Without a user, it clears the Sentry user.
 */
export const useSentryUser = (user: GetUserQuery["getUser"] | undefined) => {
  useEffect(() => {
    IssueReporter.setUser({
      id: user?.id ?? "",
      username: user?.name ?? "",
      email: user?.email ?? "",
    });
  }, [user?.id, user?.name, user?.email]);
};
